import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "name" ]
  static values = { name: String }

  async copy() {
    try {
      await navigator.clipboard.writeText(`"${this.nameValue}"`);

      this.nameTarget.classList.add("c-icon__documented-name--copied")
      setTimeout(() => {
        this.nameTarget.classList.remove("c-icon__documented-name--copied")
      }, 2000);

    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  }
}
